import { Button } from '@resideo/blueprint-oneportal';
import { useTranslation } from 'react-i18next';
import styles from './StickyFooter.module.css';

interface StickyFooterProps {
  changesCount: number;
  onCancel: () => void;
  onSave: () => void;
  isSaving?: boolean;
  saveDisabled?: boolean;
}

export function StickyFooter({
  changesCount,
  onCancel,
  onSave,
  isSaving = false,
  saveDisabled = false,
}: StickyFooterProps) {
  const { t } = useTranslation();

  const changesText =
    changesCount === 1
      ? t('stickyFooter.unsavedChangesSingular')
      : t('stickyFooter.unsavedChangesPlural', { count: changesCount });

  return (
    <div className={styles.footer}>
      {changesCount > 0 && (
        <span className={styles.changesText}>{changesText}</span>
      )}
      <div className={styles.actions}>
        <Button
          variant="highlightTertiary"
          onClick={onCancel}
          disabled={isSaving}
          style={{ fontWeight: 600 }}
        >
          {t('stickyFooter.cancel')}
        </Button>
        <Button
          variant="primary"
          onClick={onSave}
          disabled={isSaving || saveDisabled}
          style={{ fontWeight: 600 }}
        >
          {isSaving ? t('stickyFooter.saving') : t('stickyFooter.save')}
        </Button>
      </div>
    </div>
  );
}
